import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SEO } from "@/components/SEO";
import Home from "@/pages/Home";
import WhoWeAre from "@/pages/WhoWeAre";
import WhatWeDo from "@/pages/WhatWeDo";
import WhatWeHaveDone from "@/pages/WhatWeHaveDone";
import ContactUs from "@/pages/ContactUs";
import Team from "@/pages/Team";
import AdminPortal from "@/pages/AdminPortal";

// Public-site shell with nav + footer. Admin portal renders standalone.
const PublicShell = ({ children }) => (
  <>
    <Navigation />
    <main className="relative overflow-x-clip min-h-screen">{children}</main>
    <Footer />
  </>
);

const AppRoutes = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/adminportal");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/adminportal" element={<AdminPortal />} />
      </Routes>
    );
  }

  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/team" element={<Team />} />
        <Route path="/meet-the-team" element={<Team />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/what-we-have-done" element={<WhatWeHaveDone />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </PublicShell>
  );
};

function App() {
  return (
    <div className="App bg-background text-foreground">
      <BrowserRouter>
        <ScrollToTop />
        <SEO />
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
